import 'react';
import PropTypes$1 from 'prop-types';
import { useValue } from '@morningtrain/react-resources';
import { observer } from 'mobx-react';
import { format } from '@morningtrain/helpers';

function Integer(props) {
  var name = props.name,
      defaultValue = props.defaultValue;
  var value = useValue(name, defaultValue);

  if (!(typeof value === 'number')) {
    value = parseFloat(value);
  }

  if (isNaN(value)) {
    return null;
  }

  value = parseFloat(value.toFixed(0));
  return format.numberFormat(value, 0, 0);
}

Integer.defaultProps = {
  defaultValue: null
};
Integer.propTypes = {
  name: PropTypes$1.string.isRequired,
  defaultValue: PropTypes$1.any
};
var Integer$1 = observer(Integer);

export default Integer$1;
//# sourceMappingURL=Integer.js.map
